__turbopack_context__.v({
  "ai-label": "wR8gLG_ai-label",
});
